<template>
  <v-card class="dialog">
    <v-card-title class="primary">
      <span class="headline"> NOVO ENDOSSO</span>
    </v-card-title>
    <v-form v-model="validTipoEndosso" @submit.prevent>
      <v-card-text class="py-2 px-4">
        <v-radio-group :hide-details="true" required :rules="regras.notNull" v-model="idTipoEndosso">
          <v-flex py-3 v-for="item in tipoEndossoList" :key="item.titulo"
            ><v-radio :value="item.id">
              ><template v-slot:label>
                <div class="textblack" style="font-size: 14px">
                  Endosso de <b>{{ item.titulo }}</b
                  ><i>{{ "  " + getComplemento1(item) }}</i>
                </div>
              </template>
            </v-radio></v-flex
          >
        </v-radio-group>
      </v-card-text>
    </v-form>
    <v-card-actions class="px-5 pb-5">
      <v-layout row wrap>
        <v-flex md6 xs12>
          <v-btn color="primary" flat @click="fecharDialogoEndosso">
            CANCELAR
          </v-btn>
        </v-flex>
        <v-flex md6 xs12 style="display: flex; justify-content: flex-end">
          <v-btn
            :disabled="!validTipoEndosso"
            class="primary"       
            @click="proximaPagina"
            >PRÓXIMO</v-btn
          >
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios';
import usuarioHelper from "@/helpers/usuario-logado.js";

export default {
  name: "ModalEndossos",

  data: () => {
    return {
      dateInicio: new Date().toISOString().slice(0, 10),
      idTipoEndosso: null,
      dialogEndossoCancelamento: false,
      validTipoEndosso: true,
      dialogEndosso: false,
      regras: {
        notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      }
    };
  },
  props: {
    dialog: Boolean,
    item: Number,
    campos: Object,
    idApolice: Number,
    tipoEndossoList: Array,
    corretorReserva: Boolean,
    idPropostaStatus: String,
    idStatusCorretorReserva: String
  },
  methods: {
   
    getComplemento1(item) {
      if (item.id == 1)
        return "(Incluir novos itens na apólice)";
      else if (item.id == 3) return "(Remover itens da apólice)";
      else if (item.id == 4) return "(Encerrar apólice ou endosso)";
      else if (item.id == 5) return "(Substituir itens da apólice)";
      else if (item.id == 6) return "(Corrigir itens sem alterar valores)";
      else if (item.id == 7) return "(Gerar cobrança de gatilho)";
    },


    proximaPagina: function() {
      if(this.corretorReserva) {
        return this.$router.push(
          `/corretor/InfoEndosso?id=${this.idApolice}&idTipoEndosso=${this.idTipoEndosso}&idStatusCorretorReserva=${this.idStatusCorretorReserva}`
        );
      }
      if (this.idTipoEndosso != null && this.idTipoEndosso != 4) {
        return this.$router.push(
          `/GridPrincipal/InfoEndosso?id=${this.idApolice}&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
        );
      }
      this.$emit("abrirEndossoCancelamento");
    },
    fecharDialogoEndosso() {
      this.$emit("fecharDialogoEndosso");
    }
    
  }
};
</script>

<style>
.table-grid thead {
  background-color: #00456e;
}
.table-grid .column {
  color: #fff !important;
}

.table-grid th i {
  color: #fff !important;
}

.dialog {
  background: #eaeaea !important;
}

.headline {
  color: #fff;
  font-size: 14px !important;
}

.text-error {
  color: #f45353;
  font-weight: bold;
}

.name-arquivo {
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 10px 10px;
  background-color: #fff;
  border-radius: 2px;
}

input[type="file"] {
  display: none;
}

.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}

.button-custom:hover {
  background-color: #063f57;
}

.disabled,
.v-btn.button-custom:disabled {
  cursor: default;
  background-color: #063f57;
  color: #aaaaaa !important;
}

.disabled:hover {
  background-color: #063f57;
}

.click {
  cursor: pointer;
}
.size {
  size: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalEndosso.vue